import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03632ab1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["Cookies-ID"]
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "D-Flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_7 = ["CookiesInvalidInput"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = { class: "DialogSection" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_11 = { class: "DialogSection" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_13 = { class: "DialogSection" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_16 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesDropDown = _resolveComponent("CookiesDropDown")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesRadioButton = _resolveComponent("CookiesRadioButton")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "M-Auto DialogContainer",
        "Cookies-ID": _ctx.MEMRead('D_ItemLocation_Item_Value')?.ID
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: _normalizeClass([(_ctx.DialogData.Editing && !_ctx.IsEmpty) || _ctx.MEMRead('D_ItemLocation_IsFlex') === true ? 'Disabled': '', "D-Flex DialogSection"])
          }, [
            _createVNode(_component_CookiesDropDown, {
              Name: _ctx.Translate('Brand'),
              Width: '50%',
              style: {"max-width":"80%"},
              Res: 'D_Transfer_Brand',
              Options: _ctx.Brands,
              Type: 'Object',
              Selector: 'Name'
            }, null, 8, ["Name", "Options"]),
            _createVNode(_component_CookiesDropDown, {
              Name: _ctx.Translate('Category'),
              Width: '50%',
              style: {"max-width":"80%"},
              Res: 'D_Transfer_Category',
              Options: _ctx.Categories,
              Type: 'Object',
              Selector: 'Name'
            }, null, 8, ["Name", "Options"])
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CookiesDropInputObject, {
              RowHeight: '7.5em',
              Disabled: (_ctx.DialogData.Editing && !_ctx.IsEmpty) || _ctx.MEMRead('D_ItemLocation_IsFlex'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_ItemLocation_Item') && _ctx.MEMRead('D_ItemLocation_Item') !== '') && !_ctx.MEMRead('D_ItemLocation_IsFlex') === true,
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_ItemLocation_Item') && _ctx.MEMRead('D_ItemLocation_Item') !== ''),
              Name: _ctx.Translate('Item'),
              Default: '',
              Options: _ctx.FilteredItems,
              Selectors: [['Code'], ['Name'], ['CategoryName'], ['BrandName'], ['Specifications', 0, 'Description'], ['Specifications', 1, 'Description']],
              Res: 'D_ItemLocation_Item'
            }, null, 8, ["RowHeight", "Disabled", "CookiesInvalidInput", "ErrorData", "Name", "Options"]),
            _createVNode(_component_CookiesIcon, {
              class: _normalizeClass([_ctx.MEMRead('D_ItemLocation_Item_Value') ? '' : 'Disabled', "SQR1_5em V-Auto"]),
              ToolTip: _ctx.ItemInfo,
              ID: ('Info' as IconsIDs)
            }, null, 8, ["class", "ToolTip", "ID"])
          ]),
          _hoisted_6,
          _createElementVNode("div", {
            class: _normalizeClass(["D-Flex P1em", [(_ctx.ErrorsVisibilty && _ctx.MEMRead('D_ItemLocation_IsPack') === '') ? 'ErrorBorder Rad2': '', _ctx.MEMRead('D_ItemLocation_IsFlex') === true ? 'Disabled' : '']]),
            style: {"flex-wrap":"wrap","gap":"1em"},
            CookiesInvalidInput: _ctx.MEMRead('D_ItemLocation_IsPack') === '' && !_ctx.MEMRead('D_ItemLocation_IsFlex') === true
          }, [
            (_ctx.SelectedItemPackSize > 1 || !_ctx.MEMRead('D_ItemLocation_Item'))
              ? (_openBlock(), _createBlock(_component_CookiesRadioButton, {
                  key: 0,
                  class: _normalizeClass(_ctx.DialogData.Editing && !_ctx.IsEmpty ? 'Disabled': ''),
                  Default: 0,
                  Res: 'D_ItemLocation_IsPack',
                  Value: 1,
                  Name: _ctx.Translate('Pack') + '(' + _ctx.SelectedItemPackSize + ')'
                }, null, 8, ["class", "Name"]))
              : _createCommentVNode("", true),
            _createVNode(_component_CookiesRadioButton, {
              class: _normalizeClass(_ctx.DialogData.Editing && !_ctx.IsEmpty ? 'Disabled': ''),
              Res: 'D_ItemLocation_IsPack',
              Value: 0,
              Name: _ctx.Translate('Split')
            }, null, 8, ["class", "Name"])
          ], 10, _hoisted_7),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_CookiesNumberInput, {
              Default: 0,
              Min: 0,
              Max: _ctx.MEMRead('D_ItemLocation_Max'),
              Res: 'D_ItemLocation_Low',
              Name: _ctx.Translate('Low Quantity')
            }, null, 8, ["Max", "Name"]),
            _createVNode(_component_CookiesNumberInput, {
              Default: 0,
              Min: _ctx.MEMRead('D_ItemLocation_Low') > 1 ? _ctx.MEMRead('D_ItemLocation_Low') : 1,
              Res: 'D_ItemLocation_Max',
              Name: _ctx.Translate('Max Quantity')
            }, null, 8, ["Min", "Name"])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Note'),
              Res: 'D_ItemLocation_Note'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_CookiesCheckBox, {
              Type: 'Switch',
              Name: _ctx.Translate('Flex'),
              Res: 'D_ItemLocation_IsFlex',
              Default: _ctx.MEMRead('D_ItemLocation_IsFlex')
            }, null, 8, ["Name", "Default"])
          ]),
          _hoisted_14
        ])
      ], 8, _hoisted_2)
    ], 8, _hoisted_1),
    (_ctx.Access('Inventory_Items_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.DialogData.Editing ? _ctx.Translate('Save') : _ctx.Translate('Add')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}